import type { Deal } from '../service/types';

/** True when a deal has been taken down by Digipop admin moderation. */
export function isDealRemoved(deal: Pick<Deal, 'moderation_status'>): boolean {
  return deal.moderation_status === 'removed';
}
